import React from 'react';
import i1 from '../images/drop.png';
import {Dropdown}from 'react-bootstrap'

function Cbar(){
        return(
          
     <div>
<style type="text/css">
    {`
  
    .btn-xxl {
      padding: 0.8rem 1.2rem;
      font-size: 1rem;
    }
    `}
  </style>
<div className="nb">
  <div className="nbbut" >
  <Dropdown >
  <Dropdown.Toggle  className="ml-2 pb-2 topic-button"   size="xxl"  > 
  C  Topics <img src={i1} alt =""/>
  </Dropdown.Toggle>
  
  <Dropdown.Menu>
   
    <Dropdown.Item href="/c-element">C element</Dropdown.Item>
    <Dropdown.Item href="/c-variable">C variable</Dropdown.Item>
    <Dropdown.Item href="/c-scope-of-variable">C scope-of-variable</Dropdown.Item>
    <Dropdown.Item href="/c-keyword">C keyword</Dropdown.Item>
    <Dropdown.Item href="/c-identifier">C identifier</Dropdown.Item>

    <Dropdown.Item href="/c-short-cut-keys">C short-cut-keys</Dropdown.Item>
    <Dropdown.Item href="/c-first-program">C first-program</Dropdown.Item>
   
    <Dropdown.Item href="/c-input">C input</Dropdown.Item>
    <Dropdown.Item href="/c-literal">C literal</Dropdown.Item>
    <Dropdown.Item href="/c-operator">C operator</Dropdown.Item>



    <Dropdown.Item href="/c-control-structure">C control-structure</Dropdown.Item>
    <Dropdown.Item href="/c-if">C if</Dropdown.Item>
    <Dropdown.Item href="/c-if-else">C if-else</Dropdown.Item>
    <Dropdown.Item href="/c-if-else-if">C if-else-if</Dropdown.Item>
    <Dropdown.Item href="/c-switch">C switch</Dropdown.Item>
    <Dropdown.Item href="/c-looping">C looping</Dropdown.Item>

    <Dropdown.Item href="/c-while">C while</Dropdown.Item>
    <Dropdown.Item href="/c-do-while">C do-while</Dropdown.Item>
    <Dropdown.Item href="/c-for-loop">C for-loop</Dropdown.Item>
    <Dropdown.Item href="/c-break">C Break</Dropdown.Item>
    <Dropdown.Item href="/c-continue">C Continue</Dropdown.Item>
    <Dropdown.Item href="/c-array">C Array</Dropdown.Item>


    <Dropdown.Item href="/c-function">C function</Dropdown.Item>
    <Dropdown.Item href="/c-user-defined-function">C user-defined-function</Dropdown.Item>
    <Dropdown.Item href="/c-passing-argument">C Passing-argument</Dropdown.Item>
    <Dropdown.Item href="/c-history">C history</Dropdown.Item>

    </Dropdown.Menu>
</Dropdown>
</div>
</div>


        </div>
     
        );
    }

export  default Cbar;